<template>
    <v-dialog v-model="dialog" max-width="500px">
        <v-card>
            <v-card-title>
               Person
            </v-card-title>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        props: ['value', 'person'],
        name: "person",
        data () {
            return {
                dialog: false,
            }
        },
        methods: {
        },
        watch: {
            value(){
                this.dialog = this.value
            },
            dialog(){
                this.$emit('input', this.dialog)
            }
        },
        mounted() {
            this.dialog = this.value
        }
    }
</script>

<style scoped>

</style>